module.exports = __webpack_public_path__ + "static/media/search.8b7788bd.svg";